import React, { useState, useEffect } from "react";

import Link from "@mui/material/Link";

import { useTranslation } from 'react-i18next';

import OthelloVersionWeb from "../componentsothello/OthelloVersionWeb.jsx";

// Material Dashboard 2 PRO React components
import MDBox from "../components/MDBox";
import MDTypography from "../components/MDTypography";
import MDInput from "../components/MDInput";
import MDButton from "../components/MDButton";
import MDProgress from "../components/MDProgress/index.js";

import avatar from "../assets/img/default-avatar.png";
import { CircularProgress, Grid, LinearProgress } from "@mui/material";

function LoginPage({ ...props }) {
    // const { classes, t } = this.props;
    const { t } = useTranslation();

    const [initpage, setInitPage] = useState(true);
    const [version, setVersion] = useState("");

    const [submitted, setSubmitted] = useState(false);
    const [error, setError] = useState(0);
    const [errordata, setErrorData] = useState(0);
    const [errorliteral, setErrorLiteral] = useState(0);

    const [loading, setLoading] = useState(false);

    //const [rememberMe, setRememberMe] = useState(false);
    //const handleSetRememberMe = () => setRememberMe(!rememberMe);  

    React.useEffect(() => {
        fetch('api/Data/GetVersion')
            .then(response => response.json())
            .then(data => {

                //if (caches) {
                //    // Service worker cache should be cleared with caches.delete()
                //    caches.keys().then(function (names) {
                //        for (let name of names) caches.delete(name);
                //    });
                //}
                setVersion(data.version)
                setInitPage(false);                
            }).catch(error => {
                setInitPage(false)
                setVersion("")
            });
    }, [initpage]);

    const handleClick = (event) => {
        event.preventDefault();

        setLoading(true);
        setErrorData("");
        setErrorLiteral("");

        let formulario = document.getElementById('formlogin');
        var data = new FormData(formulario);

        fetch('api/Data/LoginUsuarioApp', {
            method: 'POST',
            body: data,
        }).then(response => response.json()).then(res => {

            if (!res) {
                setSubmitted(true);
                setError(1);
                setErrorData(res.exceptionmessage);
                setErrorLiteral(res.exceptionmessagetraducible);
                setLoading(false);
            }
            else {
                //this.props.history.push('admin/dashboard')
                window.location.assign('/admin/profile');
            }
        }).catch(error => {
            setSubmitted(true);
            setError(2);
        });
    }

    let errorinfo = "";

    if (errorliteral != null && errorliteral != "")
        errorinfo = <MDTypography variant="body2" color="error" fontWeight="regular">{t(errorliteral)}</MDTypography>;
    else if (errordata != null && errordata != "")
        errorinfo = <MDTypography variant="body2" color="error" fontWeight="regular">{errordata}</MDTypography>;

    return (
        <form id="formlogin">
            <MDBox >
                <MDBox mb={2}>
                    <MDInput id="email" name="email" type="text" label="Usuario o Email" autocompletado={true} fullWidth fullWidth error={submitted && error == 1 ? true : false} />
                </MDBox>
                <MDBox mb={2}>
                    <MDInput id="pass" name="pass" type="password" label="Password" fullWidth error={submitted && error == 1 ? true : false} />
                </MDBox>
                {/*<MDBox display="flex" alignItems="center" ml={-1}>*/}
                {/*    <Switch checked={rememberMe} onChange={handleSetRememberMe} />*/}
                {/*    <MDTypography*/}
                {/*        variant="button"*/}
                {/*        fontWeight="regular"*/}
                {/*        color="text"*/}
                {/*        onClick={handleSetRememberMe}*/}
                {/*        sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}*/}
                {/*    >*/}
                {/*        &nbsp;&nbsp;Remember me*/}
                {/*    </MDTypography>*/}
                {/*</MDBox>*/}
                <MDBox mt={4} mb={1}>
                    <MDButton variant="gradient" color="info" size="large" onClick={(e) => handleClick(e)} fullWidth>
                        Entrar
                    </MDButton>                    
                </MDBox>
                {loading ? <MDBox mt={2} mb={1} justifyContent={'center'}><center> <CircularProgress /></center> </MDBox> : ""}
                {errorinfo}
                <MDBox mt={3} textAlign="center">
                    <MDTypography variant="button" color="info">
                        <Link onClick={() => {
                            window.location.assign('/authapps/register');
                        }} >Registrate</Link>
                    </MDTypography>
                    <MDTypography variant="button" color="info" ml={2}>
                        <Link onClick={() => {
                            window.location.assign('/authapps/rememberpass');
                        }} >He olvidado mi contrase&ntilde;a</Link>
                    </MDTypography>
                </MDBox>
                <MDBox mt={3} textAlign="center">
                    <MDTypography variant="button" color="text">                                               
                        <Link href={"https://atmovilidad.com/"} target="_blank">
                            <MDTypography
                                variant="button"
                                color="info"
                                fontWeight="medium"
                                textGradient>
                                Accede a nuestra web
                            </MDTypography>
                        </Link>
                    </MDTypography>
                </MDBox>
                <MDBox py={3} px={3} textAlign="center" fontSize={12} >
                    <OthelloVersionWeb />
                </MDBox>
            </MDBox>
        </form>
    );
}

export default LoginPage;
